"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageContent = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
require("./atoms.pc");
require("./PageContent.pc.css");
const PageContent = ({ className, spaceLeft, center, padded, fixedWidth, bottomSpace, topSpace, testId, children, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_7b9f494e', '_1a73c72a', '_pub-1a73c72a', '_pub-3c25d522', {
            '_1a73c72a_space-left _pub-1a73c72a_space-left _pub-3c25d522_space-left space-left': spaceLeft,
            '_1a73c72a_center _pub-1a73c72a_center _pub-3c25d522_center center': center,
            '_1a73c72a_padded _pub-1a73c72a_padded _pub-3c25d522_padded padded': padded,
            '_1a73c72a_fixed-width _pub-1a73c72a_fixed-width _pub-3c25d522_fixed-width fixed-width': fixedWidth,
            '_1a73c72a_bottom-space _pub-1a73c72a_bottom-space _pub-3c25d522_bottom-space bottom-space': bottomSpace,
            '_1a73c72a_top-space _pub-1a73c72a_top-space _pub-3c25d522_top-space top-space': topSpace,
        }, className), "data-testid": testId },
        react_1.default.createElement("div", { className: (0, clsx_1.default)('_51d7a80a', '_1a73c72a', '_pub-1a73c72a', '_pub-3c25d522', {
                '_1a73c72a_space-left _pub-1a73c72a_space-left _pub-3c25d522_space-left space-left': spaceLeft,
                '_1a73c72a_center _pub-1a73c72a_center _pub-3c25d522_center center': center,
                '_1a73c72a_padded _pub-1a73c72a_padded _pub-3c25d522_padded padded': padded,
                '_1a73c72a_fixed-width _pub-1a73c72a_fixed-width _pub-3c25d522_fixed-width fixed-width': fixedWidth,
                '_1a73c72a_bottom-space _pub-1a73c72a_bottom-space _pub-3c25d522_bottom-space bottom-space': bottomSpace,
                '_1a73c72a_top-space _pub-1a73c72a_top-space _pub-3c25d522_top-space top-space': topSpace,
            }) }, children)));
};
exports.PageContent = PageContent;
//# sourceMappingURL=PageContent.js.map